module.exports = __webpack_public_path__ + "img/LOGO_STEFANO_RICCI.3681e552.svg";